import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { ADPResourceService, CustomFormControl } from 'digital-core';
import { CountryCode, isValidPhoneNumber } from 'libphonenumber-js';
import { combineLatest, concatMap, filter, tap } from 'rxjs';
import { DeviceInventoryService } from 'src/app/core/services/device-inventory.service';
import { DeviceDto } from 'src/app/core/services/device-inventory/device.dto';
import { InventoryInfoDto } from 'src/app/core/services/device-inventory/inventory-info.dto';
import { ISelectedContract, LoggedInUserSettings } from 'src/app/core/services/settings/logged-in-user-settings';
import { UtilityService } from 'src/app/core/services/utility.service';
import { PghUserDeviceBase } from 'src/app/shared/device/pgh-user-device';
import { SelectedDeviceService } from 'src/app/shared/device/selected-device.service';
import { StorageService } from 'src/app/core/services/storage.service';

@Component({
  selector: 'pgh-confirm-number',
  templateUrl: './confirm-number.component.html',
  styleUrls: ['./confirm-number.component.scss']
})
export class ConfirmNumberComponent implements OnInit {
  @Output() nextEvent = new EventEmitter();
  @Output() backEvent = new EventEmitter();
  @Input() isOnboardingFlow?: boolean = false;
  @Input() device?: PghUserDeviceBase;
  countryIso: CountryCode = 'US';

  public updatePhoneInfoForm: UntypedFormGroup;

  programCode: string;
  phoneDevice: PghUserDeviceBase;
  public contractPhoneNumber: string;
  private phoneInventoryInfo?: InventoryInfoDto;
  private phoneDevices?: DeviceDto[];

  constructor(
    public resourceService: ADPResourceService,
    private deviceInventoryService: DeviceInventoryService,
    private storageService: StorageService,
  ) { }


  ngOnInit(): void {

    let newUserPhoneDevice = this.storageService.getSession<DeviceDto>('NewUserDevice');

    if (!newUserPhoneDevice) {
      this.contractPhoneNumber = this.device?.lineNumber;
      this.phoneDevice = this.device;
    } else {
      this.contractPhoneNumber = newUserPhoneDevice.lineNumber;
      this.phoneDevice = this.deviceInventoryService.buildPghUserDeviceBaseFromDeviceDto(newUserPhoneDevice);
    }

    this.updatePhoneInfoForm = new UntypedFormGroup({
      mobileNumber: new CustomFormControl({ value: this.contractPhoneNumber, disabled: true }, [Validators.required, this.validatePhone.bind(this)]),
      differentMobileNumber: new UntypedFormControl('')
    });
  }

  validatePhone(control: UntypedFormControl) {
    if (control?.value != null) {
      let phNumber = control.value.replace(/[^0-9]/g, "");
      let checkPH = isValidPhoneNumber(phNumber, this.countryIso);
      if (!this.isValidPhoneFormat(control.value)) {
        return { invalidFormat: true };
      } else if (!checkPH) {
        return { invalid: true };
      }
    }
  }
  isValidPhoneFormat(phoneNumber) {
    var isphone = /^[+]?(1\-|1\s|1|\d{3}\-|\d{3}\s|)?((\(\d{3}\))|\d{3})(\-|\s)?(\d{3})(\-|\s)?(\d{4})$/g.test(phoneNumber);
    return isphone;
  }

  public handleConfirmNumber() {

    let data:any[] = [];

    data.push([]);
    data[0].phoneNumber = this.updatePhoneInfoForm.controls.mobileNumber.value;
    data[0].device = this.phoneDevice;

    this.nextEvent.emit(data);
  }

  onCheckboxChanged(event: any): void {
    if (event.checked) {
      this.updatePhoneInfoForm.controls.mobileNumber.enable();
    }
    else {
      this.updatePhoneInfoForm.controls.mobileNumber.setValue(this.contractPhoneNumber)
      this.updatePhoneInfoForm.controls.mobileNumber.disable();
    }
  }

}
